import React from 'react';

const PersonalSettings = ({
  width = '1.4rem',
  height = '1.4rem',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 19.196"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g data-name="Group 1998" transform="translate(4999 7331)">
      <path
        transform="translate(-5191 -10044.682)"
        d="M200.705,2723.913a2.593,2.593,0,0,1,.361-.467.39.39,0,0,0,.108-.333.4.4,0,0,0-.212-.292,6.313,6.313,0,0,0-8.945,3.541.4.4,0,0,0,.065.358.423.423,0,0,0,.334.158h7.789a.417.417,0,0,0,.352-.183.387.387,0,0,0,.027-.383A2.507,2.507,0,0,1,200.705,2723.913Z"
      />
      <path
        transform="translate(-5191.375 -10043)"
        d="M198.207,2719.6a3.8,3.8,0,1,0-3.958-3.8A3.88,3.88,0,0,0,198.207,2719.6Z"
      />
      <path
        fillRule="evenodd"
        transform="translate(-5192.911 -10044.611)"
        d="M213.711,2724.451a1.382,1.382,0,0,1-.2,1.683l-.822.85a.359.359,0,0,0,0,.5l.822.85a1.382,1.382,0,0,1,.2,1.683,1.52,1.52,0,0,1-1.616.683l-1.176-.267a.378.378,0,0,0-.444.25l-.353,1.116a1.5,1.5,0,0,1-2.833,0l-.353-1.116a.379.379,0,0,0-.444-.25l-1.176.267a1.52,1.52,0,0,1-1.616-.683,1.382,1.382,0,0,1,.2-1.683l.823-.85a.359.359,0,0,0,0-.5l-.823-.85a1.382,1.382,0,0,1-.2-1.683,1.52,1.52,0,0,1,1.616-.683l1.175.267a.379.379,0,0,0,.444-.25l.353-1.116a1.5,1.5,0,0,1,2.833,0l.353,1.116a.379.379,0,0,0,.444.25l1.176-.267A1.52,1.52,0,0,1,213.711,2724.451Zm-7.5,2.783a2.5,2.5,0,1,0,2.5-2.4A2.451,2.451,0,0,0,206.207,2727.234Z"
      />
    </g>
  </svg>
);

export default PersonalSettings;
